import React from 'react'
import { connect } from 'react-redux'

import { SelectField } from 'discada/dist/Form'

import { dateOptions } from 'utils'
import { getSelectedDateRange } from 'selectors/naughtySelectors'
import { addToPageState } from 'actions/pageStateActions'

import eye from 'static/images/illumiNAUGHTY.png'

import './DateRangeSelector.scss'

export function DateRangeSelector({
  ns,
  selectedDateRange,
  addToPageState,
  size,
}) {
  return (
    <div className="stat-filters">
      <img src={eye} alt="The All-Seeing Eye" />
      <SelectField
        size={size}
        value={selectedDateRange}
        onChange={({ target }) =>
          addToPageState({ [`${ns ? ns + '.' : null}dateRange`]: target.value })
        }
      >
        {Object.keys(dateOptions).map(k => (
          <option key={k} value={k}>
            {dateOptions[k].label}
          </option>
        ))}
      </SelectField>
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    ns: op.ns || 'stats',
    selectedDateRange: op.selectedDateRange || getSelectedDateRange(state),
  }
}

export default connect(
  mapStateToProps,
  { addToPageState },
)(DateRangeSelector)
